export function calculateLdlHdlRatio(ldl: number, hdl: number): number {
    if (hdl <= 0 || ldl <= 0) {
        throw new Error('Expected HDL and LDL to be greater than 0');
    }

    return (ldl + hdl) / hdl;
}

export function calculateLdlHdlRatioString(ldl: number, hdl: number): string {
    return calculateLdlHdlRatio(ldl, hdl).toLocaleString('nl-NL', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });
}
